import { MatButtonModule} from '@angular/material/button';
import { MatCardModule} from '@angular/material/card';
import { MatCheckboxModule} from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule} from '@angular/material/input';
import { MatSelectModule} from '@angular/material/select';
import { MatBadgeModule } from '@angular/material/badge';
import { MatMenuModule} from '@angular/material/menu';
import { MatMomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE, DateAdapter } from '@angular/material/core';
import { NgModule } from '@angular/core';
import { MatDialogModule} from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { CdkScrollableModule } from '@angular/cdk/scrolling';

@NgModule({
    imports: [
        MatCheckboxModule,
        MatSelectModule,
        MatExpansionModule,
        MatCardModule,
        MatDividerModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatBadgeModule,
        MatMenuModule,
        MatDialogModule,
        MatTabsModule,
        CdkScrollableModule
    ],
    exports: [
        MatCheckboxModule,
        MatSelectModule,
        MatExpansionModule,
        MatCardModule,
        MatDividerModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatBadgeModule,
        MatMenuModule,
        MatDialogModule,
        MatTabsModule,
        CdkScrollableModule
    ],
    providers: [
        {
            provide: MAT_DATE_LOCALE,
            useValue: 'en-GB'
        },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE]
        }]
})
export class B2BAngularMaterialModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/angular.material/b2b.angular.material.module.ts